import { Box, styled } from '@mui/material';

const FixedWidthCenteredContainer = styled(Box)({
  maxWidth: 640,
  margin: '0 auto',
});

export default FixedWidthCenteredContainer;
